export default {"src":"/_next/static/media/tusd.60476e24.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};